import classNames from 'classnames';
import DataController from 'components/DataController/DataController';
import Text from 'components/Text/Text';
import { IItemScheduledPush } from 'types';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import moment from 'moment';
import React, { useContext } from 'react';
import style from './Item.module.scss';

interface IItem {
	data: IItemScheduledPush;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion, setIDForEdit } = useContext<IScheduleViewContext>(ScheduleViewContext);

	const pushesRowClasses = classNames(style.pushes, style.row);
	const statusRowClasses = classNames(style.status, style.row);
	const dateTimeRowClasses = classNames(style.dateTime, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const formattedDate = moment(data.scheduledDateTime).format('DD.MM.YYYY / HH:mm');

	const hideActions = data.status === 'Failed' || data.status === 'Sent';

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	const handleEdit = () => {
		setIDForEdit(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={style.container}>
				<Text
					className={pushesRowClasses}
					translationNameSpace="form"
					translationKey={data.type}
					withTooltip={true}
				/>
				<Text
					className={statusRowClasses}
					translationNameSpace="form"
					translationKey={data.status}
					withTooltip={true}
				/>
				<Text className={dateTimeRowClasses} translationKey={formattedDate} withTooltip={true} />
				<div className={actionRowClasses}>
					{!hideActions && (
						<DataController
							onClickDelete={handleSetIdForDeletion}
							onClickEdit={handleEdit}
							size="smallBtn"
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default Item;
